import { SnSize } from '@lib/common/types';
import { SnPointLike } from '@lib/geo/helpers';
import { SnBadgeConfig } from '@lib/ui/badge';

import { IBaseMarkerOptions } from './base-marker-options';

export interface IGoogleMapFontIcon {
  fontIcon: string;
  fontSet: string;
  size?: SnSize;
}

export interface IGoogleMapFontIconUnicode {
  fontIconUnicode: string;
  fontSet: string;
}

export interface IGoogleMapNameIcon {
  name: string;
}

export interface IGoogleMapIconMarkerOptions extends IBaseMarkerOptions {
  scale?: number;
  color?: string;
  anchor?: SnPointLike;
  badge?: SnBadgeConfig;
}

export type GoogleMapIconMarkerIcon = string | IGoogleMapFontIcon | IGoogleMapFontIconUnicode;

export type GoogleMapIconMarkerOptions =
  | (IGoogleMapNameIcon & IGoogleMapIconMarkerOptions)
  | (IGoogleMapFontIcon & IGoogleMapIconMarkerOptions)
  | (IGoogleMapFontIconUnicode & IGoogleMapIconMarkerOptions);
